import { create } from 'zustand';

export const useModalStore = create((set) => ({
    visible: false,
    component: <></>,
    width: 'auto',
    height: 'auto',
    openModal: (component, width = 'auto', height = 'auto') => set(({ 
        visible: true, 
        component,
        width,
        height
    })),
    closeModal: () => set((state) => ({
        ...state,
        visible: false,
        component: <></>
    }))
}));